"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _states = require("@/api/master/states");
var _utils = require("@/utils");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.total = 0;
    this.listLoading = true;
    this.listQuery = {
      page: 1,
      limit: 10,
      name: undefined,
      code: undefined,
      enabled: true,
      sort: 'priority,ASC',
      filter: {
        name: '$contL',
        code: '$contL',
        enabled: '$eq'
      }
    };
  }
  created() {
    this.getList();
  }
  async getList() {
    this.listLoading = true;
    try {
      const data = await (0, _states.getStates)((0, _utils.getQuery)(this.listQuery));
      this.list = data.data;
      this.total = data.total;
    } finally {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'StateList',
  components: {
    Pagination: _index.default
  }
})], default_1);
var _default = exports.default = default_1;